/** 同类目内取未占用的最小非负优先级（数字越小越优先）。 */
export function nextTemplatePriority(items = [], excludeId = null) {
  const used = new Set();
  (Array.isArray(items) ? items : []).forEach((item) => {
    if (excludeId != null && String(item?.id) === String(excludeId)) return;
    const n = Number(item?.sortOrder);
    if (Number.isFinite(n)) used.add(n);
  });
  let p = 0;
  while (used.has(p)) p += 1;
  return p;
}
